import { z } from 'zod';

// お問い合わせフォームのバリデーションスキーマ
export const contactFormSchema = z.object({
  lastName: z.string().min(1, '姓は必須です').max(50, '姓は50文字以内で入力してください'),
  firstName: z.string().min(1, '名は必須です').max(50, '名は50文字以内で入力してください'),
  phone: z
    .string()
    .min(1, '電話番号は必須です')
    .regex(/^[\d\-()\s]+$/, '正しい電話番号の形式で入力してください')
    .refine(val => val.replace(/[\d]/g, '').length < val.length, {
      message: '正しい電話番号の形式で入力してください',
    }),
  email: z
    .string()
    .min(1, 'メールアドレスは必須です')
    .email('正しいメールアドレスの形式で入力してください'),
  eventName: z.string().max(100, '公演名or商品名は100文字以内で入力してください').optional(),
  reservationNumber: z.string().max(50, '申し込み番号は50文字以内で入力してください').optional(),
  inquiryContent: z
    .string()
    .min(1, 'お問い合わせ内容は必須です')
    .max(1000, 'お問い合わせ内容は1000文字以内で入力してください'),
  privacyPolicy: z.boolean().refine(val => val === true, {
    message: '個人情報の取り扱いについて同意してください',
  }),
});

// バリデーション済みのフォームデータの型
export type ContactFormData = z.infer<typeof contactFormSchema>;

// バリデーションエラーの型
export type ContactFormErrors = z.ZodError<ContactFormData>;
